module.exports = "/static/assets/f2b99ab8bc69d7ea36532138c98abfa7.gif";